import AppConstants from '../config/app.constants';

let MonthlyReportService = function ($http, $q) {

    let getMonthlyReport = (startDate, endDate, searchText, offset, limit) => {
        return $http
            .post(AppConstants.api + `/monthly-report/get-monthly-report`, {
                startDate,
                endDate,
                searchText,
                offset,
                limit
            })
            .then((res) => {
                return res.data
            })
    }

    let exportDataToCSV = (searchText, startDate, endDate, offset, limit) => {
        return $http
            .post(AppConstants.api + `/monthly-report/export-to-csv`, {
                searchText,
                startDate,
                endDate,
                offset,
                limit
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        getMonthlyReport,
        exportDataToCSV
    }
};

MonthlyReportService.$inject = ['$http', '$q'];

export default MonthlyReportService;


// WEBPACK FOOTER //
// ./client/app/services/monthly-report.service.js